import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import HeroImage from "../../images/heroImg.gif";
import PeopleSVG from "./SVG/PeopleSVG";

import "./Hero.css";

const Hero = () => {
  const heroCounter = () => {
    const counters = document.querySelectorAll(".hero__counter");

    counters.forEach((counter) => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const increment = target / 1000;
        const count = +counter.innerText;

        if (count < target) {
          counter.innerText = Math.ceil(count + increment);
          setTimeout(updateCount, 1);
        } else {
          counter.innerText = target;
        }
      };

      updateCount();
    });
  };

  useEffect(() => {
    const counterCtn = document.querySelector(".hero__bottom__infos");
    const counters = document.querySelectorAll(".hero__counter");

    const options = {
      threshold: 0.1,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          heroCounter();
        } else {
          counters.forEach((counter) => {
            counter.innerText = 0;
          });
        }
      });
    }, options);

    observer.observe(counterCtn);
  }, []);

  useEffect(() => {
    const textArray =
      "We keep the promise of bringing you closer to entire globe, by breaking down language barriers and providing a clearer integration to engage world. We offer translation services tailored to suit your needs that meet the highest standards of accuracy and brevity. We provide high quality, natural sounding and swift services for a variety of 350 international languages.";
    const typingDelay = 60;
    let charIndex = 0;

    const type = () => {
      const textElement = document.querySelector(".hero__top__info");
      if (textElement && charIndex < textArray.length) {
        textElement.textContent += textArray.charAt(charIndex);
        charIndex++;
        setTimeout(type, typingDelay);
      }
    };

    const timer = setTimeout(type, 20);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let i = 0;

    const content = [
      "Authorized Translation & Interpretation Services",
      "Your one-stop company for translation services",
      "Translate your documents anytime & anywhere",
      "We build bridges for businesses, culture & people",
    ];

    const colors = [
      "var(--primary-color)",
      "var(--bg-light-blue)",
      "var(--bg-light-orange)",
      "var(--bg-light-blue)",
    ];

    const showHeaders = () => {
      document.querySelector(".hero__title").innerHTML = content[i];
      document.querySelector(".hero__title").style.color = colors[i];

      if (i >= content.length - 1) i = 0;
      else i++;
    };

    showHeaders();

    const intervals = setInterval(showHeaders, 7000);
    return () => clearInterval(intervals);
  });

  return (
    <div className="hero overflow-hidden">
      <div className="hero__top bg-black d-flex justify-center position-relative">
        <div className="container d-flex align-center justify-between w-100">
          <div className="hero__top__left">
            <h2 className="hero__title font-subhead font-bolder lh-sm">
              &nbsp;
            </h2>
            <p className="hero__top__info  mt-10 font-normal font-heavy"></p>
            <Link to="/quote">
              <button className="button button-lg bg-orange font-normal p-20 mt-20">
                REQUEST A QUOTE
              </button>
            </Link>
          </div>
          <div className="hero__top__right flex-row-reverse">
            <img src={HeroImage} alt="" />
          </div>
        </div>
      </div>
      <div className="hero__bottom bg-black-reverse container d-flex flex-column align-center">
        <div className="hero__bottom__infos d-flex grid-4 justify-between px-20 py-40 box-shadow-sm rounded z-2 w-100">
          <div className="border-right-2 d-flex align-center">
            <span>
              <PeopleSVG />
            </span>
            <div className="hero__bottom__info__key pl-20 font-big font-heavy">
              <span
                className="hero__counter font-bigger font-bolder"
                data-target="1000"
              >
                0
              </span>
              <br />
              Employees
            </div>
          </div>
          <div className="border-right-2 d-flex align-center">
            <span>
              <PeopleSVG />
            </span>
            <div className="hero__bottom__info__key pl-20 font-big font-heavy">
              <span
                className="hero__counter font-bigger font-bolder"
                data-target="5000"
              >
                0
              </span>
              <br />
              Clients
            </div>
          </div>
          <div className="border-right-2 d-flex align-center">
            <span>
              <PeopleSVG />
            </span>
            <div className="hero__bottom__info__key pl-20 font-big font-heavy">
              <span
                className="hero__counter font-bigger font-bolder"
                data-target="100000"
              >
                0
              </span>
              <br />
              Projects
            </div>
          </div>
          <div className="d-flex align-center">
            <span>
              <PeopleSVG />
            </span>
            <div className="hero__bottom__info__key pl-20 font-big font-heavy">
              <span className="font-bigger font-bolder">
                <span className="hero__counter" data-target="99.99">
                  0
                </span>
                %
              </span>
              <br />
              Satisfaction
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
